module.exports = __webpack_public_path__ + "static/media/19.8a9e6d6a.jpg";